import React, { useState, useEffect } from "react";
import { fetchAPI, getStrapiMedia } from '../../utils/api';

const PortfolioTwo = () => {
  const [works, setWorks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [worksRes, categoriesRes] = await Promise.all([
          fetchAPI('/works', { populate: ['image', 'categories'] }),
          fetchAPI('/categories')
        ]);

        if (categoriesRes.data) {
          const cats = categoriesRes.data.map(c => ({
            id: c.name.toLowerCase().replace(/\s+/g, '-'),
            label: c.name
          }));
          // Ensure "All" is present
          setCategories([{ id: 'all', label: 'All' }, ...cats]);
        }

        if (worksRes.data) {
          const formattedWorks = worksRes.data.map(work => {
            const workCats = work.categories ? work.categories.map(c => c.name.toLowerCase().replace(/\s+/g, '-')) : [];
            return {
              id: work.id,
              title: work.title,
              image: getStrapiMedia(work.image),
              // Maintain the stringified JSON format if that's what the filtering script expects, 
              // or just use the array if the script handles it. 
              // The original code had: categories: '["app-design", "ui-ux"]'
              // and <div data-groups={item.categories}>
              // If the script expects a stringified array in data-groups, we should provide that.
              categories: JSON.stringify(workCats),
              projectLink: `/work/${work.documentId}` // Using documentId for links as per Strapi v5
            };
          });
          setWorks(formattedWorks);
        }

      } catch (error) {
        console.error("Error fetching portfolio data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const getCategoryCount = (categoryId) => {
    if (categoryId === 'all') return works.length.toString().padStart(2, "0");
    return works.filter(work => {
      try {
        return JSON.parse(work.categories).includes(categoryId);
      } catch (e) {
        return false;
      }
    }).length.toString().padStart(2, "0");
  };

  if (loading) return <div>Loading...</div>;

  return (
    <section className="works explore-area portfolio-filter pt-0">
      <div className="container p-0">
        <div className="row justify-content-center text-center">
          <div className="col-12">
            <div className="btn-group filter-menu" role="group" aria-label="Basic radio toggle button group">
              {categories.map(({ id, label }) => (
                <div key={id} className="input-item d-flex">
                  <div className="content">
                    <input type="radio" className="btn-check filter-btn" name="shuffle-filter" id={id} defaultValue={id} defaultChecked={id === "all"} />
                    <label className="btn" htmlFor={id}>{label}</label>
                  </div>
                  <span className="count">{getCategoryCount(id)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="row filter-items items inner">
          {/* Dynamically rendering Portfolio Items */}
          {works.map((item) => (
            <div key={item.id} className="col-12 col-lg-4 item filter-item" data-groups={item.categories}>
              {/* Portfolio Item */}
              <div className="card portfolio-item layout-2 scale has-shadow">
                <div className="image-holder">
                  {/* Card Thumb */}
                  <a className="card-thumb" href={item.projectLink}>
                    <img src={item.image} alt={item.title} />
                  </a>
                </div>
                {/* Card content */}
                <div className="card-content p-2">
                  <div className="heading">
                    <h4 className="title mt-2 mt-md-3 mb-3">{item.title}</h4>
                    <div className="show-project">
                      <div className="card-terms">
                        {typeof item.categories === "string"
                          ? JSON.parse(item.categories).map((category, index) => (
                            <a key={index} className="terms badge" href="/portfolio">
                              {category.replace("-", " ")}
                            </a>
                          ))
                          : null}
                      </div>
                      <div className="project-link">
                        <a href={item.projectLink}>Show Project</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioTwo;

